<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th>
          <span jhiTranslate="insurance-items-list.position">Position</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th jhiSortBy="itemsNature">
          <span jhiTranslate="insurance-items-list.itemsNature">ItemsNatue</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th jhiSortBy="maxValue">
          <span jhiTranslate="insurance-items-list.maxValue">maxValue</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th jhiSortBy="basePricing">
          <span jhiTranslate="insurance-items-list.basePricing">basePricing</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th jhiSortBy="pricingRate">
          <span jhiTranslate="insurance-items-list.pricingRate">pricingRate</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th jhiSortBy="insuranceRate">
          <span jhiTranslate="insurance-items-list.insuranceRate">insuranceRate</span>
          <!--<fa-icon icon="sort"></fa-icon>-->
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let insuranceItem of insuranceItems; trackBy: trackId; let index = index">
        <td>{{ insuranceItem.position }}</td>
        <td>
          <span class="no-capitalize" [mdbTooltip]="insuranceItem.itemsNature ?? ''">{{ insuranceItem.itemsNature }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.maxValue | currency: 'EUR' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.basePricing | currency: 'EUR' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.pricingRate | number: '1.2-2' }}</span>
        </td>
        <td>
          <span>{{ insuranceItem.insuranceRate | number: '1.2-2' }}</span>
        </td>
        <td>
          <div class="d-flex justify-content-end">
            <a (click)="edit(insuranceItem)" [mdbTooltip]="'entity.action.edit' | translate" mdbBtn [floating]="true" [outline]="true" size="sm" color="primary">
              <mdb-icon fas icon="pencil-alt"></mdb-icon>
            </a>
            <a (click)="delete(insuranceItem)" [mdbTooltip]="'entity.action.delete' | translate" mdbBtn [floating]="true" size="sm" color="primary">
              <mdb-icon fas icon="times"></mdb-icon>
            </a>
          </div>
        </td>
      </tr>
      <tr *ngIf="!isHidden()" class="text-center">
        <td colspan="7" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="insurance-items-list.noData">No InsuranceItem</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
